var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error w-100 d-flex text-center text-danger p-3"},[_vm._v(" An error occurred while loading component ")])
}
var staticRenderFns = []

export { render, staticRenderFns }